import BaseModelAPI from '../BaseModelAPI';

export default class SchedulerCronInterval extends BaseModelAPI {
	static entity = 'schedulercroninterval';
	static entityName = 'schedulercroninterval';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}